module.exports = __webpack_public_path__ + "img/photo.8956e5ff.jpg";